// extracted by mini-css-extract-plugin
export default {"wrapper":"alignCenter_wrapper__NLEY0"};